import React from "react"
import PropTypes from "prop-types"
import ChartODD13EmissionByMonth from "views/molecules/canvases/charts/ChartODD13EmissionByMonth"
import ChartODD13Co2AndWebsitesMaturityConsolidatedMolecule from "views/molecules/canvases/charts/ChartODD13Co2AndWebsitesMaturityConsolidatedMolecule"

const ChartODD13EmissionByMonthOrWebsitesMaturityMolecule = ({ score }) => {
  if (score?.odd13_co2_and_websites_maturity_consolidated?.datasets?.length) {
    return <ChartODD13Co2AndWebsitesMaturityConsolidatedMolecule score={score} />
  }

  return <ChartODD13EmissionByMonth score={score} />
}

ChartODD13EmissionByMonthOrWebsitesMaturityMolecule.propTypes = {
  score: PropTypes.object.isRequired,
}

export default ChartODD13EmissionByMonthOrWebsitesMaturityMolecule
